import { z } from "zod";

export const architectureEnum = z.union([
  z.object({
    label: z.literal("Distributed"),
    value: z.literal("distributed"),
  }),
  z.object({ label: z.literal("Hybrid"), value: z.literal("hybrid") }),
  z.object({
    label: z.literal("Centralized"),
    value: z.literal("centralized"),
  }),
]);

export const defaultClusterOption = z.object({
  label: z.string(),
  value: z.number().int().positive().min(1),
});

export const collaboratorOption = z.object({
  label: z.string().min(1),
  value: z.number().int().positive(),
});
